angular.module('FlexyBeautyApp.services').factory('SaleAdvanceView', [
    "$log", "$filter", "$dialog", "SiteData", "Payment", "SaleData", "DaySrv", "SaleProductView",
    "SaleServiceView", "SaleCureView", "LoyaltyCardItemView", "Transaction", "SaleSrv", "Sale", "CustomerView",
    "DayView", "BookingData", "DayData", "GiftItemView", "PaymentView", "Day", "HumanResourceData", "CurrencyManager",
    "NumberSeparatorType", "gettextCatalog", "IOSDevice", "Countries", "SaleStatus", "SalePaymentType",
    "BookingSaveTransactionOrigin", "SalePaymentTypeFactory", "BasicAuthRoleFactory", "PaymentDataObject",
    "SaleSettings", "SalePartnerSettingsFactory", "Brand","HumanResourceView", "SiteView",
    function ($log, $filter, $dialog, SiteData, Payment, SaleData, DaySrv, SaleProductView,
              SaleServiceView, SaleCureView, LoyaltyCardItemView, Transaction, SaleSrv, Sale,
              CustomerView, DayView, BookingData, DayData, GiftItemView, PaymentView, Day,
              HumanResourceData, CurrencyManager, NumberSeparatorType, gettextCatalog, IOSDevice,
              Countries, SaleStatus, SalePaymentType, BookingSaveTransactionOrigin,
              SalePaymentTypeFactory, BasicAuthRoleFactory, PaymentDataObject, SaleSettings, SalePartnerSettingsFactory,
              Brand, HumanResourceView, SiteView) {

        let SaleAdvanceView = function (saleAdvance, posView) {
            this.id = null;
            this.status = "advance";
            this.timeCreated = null;
            this.timeModified = null;
            this.customerView = null;
            this.customerLabel = "";
            this.bookingView = null; // TODO GET BOOKING VIEW
            this.dayId = null;
            this.dayView = null;
            this.posView = null;
            this.estimationNumber = null;
            this.advanceNumber = null;
            this.hrSellerView = null;
            this.hrOpView = null;
            this.siteView = null;
            this.siteV = null;
            this.softV = null;
            this.signature = null;
            this.pSignature = null;
            this.signatureCode = null;
            this.dsignatureCode = null;
            this.vat = 0;
            this.vatCode = null;
            this.oExt = null;
            this.servicesPrice = 0;
            this.productsPrice = 0;
            this.curesPrice = 0;
            this.giftItemsPrice = 0;
            this.loyaltyCardsPrice = 0;
            this.servicesPriceWithD = 0;
            this.productsPriceWithD = 0;
            this.curesPriceWithD = 0;
            this.giftItemsPriceWithD = 0;
            this.loyaltyCardsPriceWithD = 0;
            this.price = 0;
            this.priceHT = 0;
            this.priceTurnover = 0;
            this.priceTurnoverHT = 0;
            this.vatPrice = 0;
            this.advancePrice = 0;
            this.advancePercent = posView && posView.domainView && posView.domainView.advancePercent ? posView.domainView.advancePercent : 30; //only for view
            this.realPaidPrice = 0;
            this.payedPrice = 0;
            this.discountPercent = 0;
            this.isCreatedByCustomer = false;
            this.isOccasionalCustomer = false;
            this.nbPrint = 0;
            this.loyaltyCardItemView = null;
            this.nbLoyaltyCardGoal = 0;
            this.loyaltyDiscount = 0;
            this.loyaltyPts = 0;
            this.loyaltyUsedPts = 0;
            this.totalLoyaltyPts = 0;
            this.hasLoyaltyDiscount = false;
            this.isValidLoyaltyPoints = true;
            this.loyaltyDate = null;
            this.companyName = null;
            this.hasUnpaid = false;
            this.paymentsView = [];
            this.saleServicesView = [];
            this.saleProductsView = [];
            this.saleCuresView = [];
            this.giftItemsView = [];
            this.loyaltyCardItemsView = [];

            this.hasGiftItems = false;
            this.vatLines = []; // list of taxes applied (only on view)  {tax,amount}
            this.printWindow = null;

            this.customerLastname = null;
            this.customerFirstname = null;
            this.customerAddress = null;
            this.customerZip = null;
            this.customerCity = null;
            this.shareCapital = null;
            this.greffeCity = null;
            this.juridicForm = null;

            this.loadDataFrom(saleAdvance, posView);
        };

        SaleAdvanceView.prototype.loadDataFrom = function (saleAdvance, posView) {
            if (saleAdvance) {
                this.loadPropertiesDataFrom(saleAdvance, posView);
                this.loadSaleServicesDataFrom(saleAdvance);
                this.loadSaleProductsDataFrom(saleAdvance);
                this.loadSaleCuresDataFrom(saleAdvance);
                this.loadGiftItemsDataFrom(saleAdvance);
                this.loadLoyaltyCardItemsDataFrom(saleAdvance);

            }
            this.calculateSaleFields();
        };

        SaleAdvanceView.prototype.loadPropertiesDataFrom = function (saleAdvance, posView) {
            if (saleAdvance) {
                this.id = saleAdvance.id;
                this.posView = posView;
                this.timeCreated = typeof saleAdvance.timeCreated === "number" ? new Date(saleAdvance.timeCreated) : saleAdvance.timeCreated;
                this.timeModified = typeof saleAdvance.timeModified === "number" ? new Date(saleAdvance.timeModified) : saleAdvance.timeModified;
                this.customerId = saleAdvance.customerId;
                if (saleAdvance.customer !== null) {
                    this.customerView = new CustomerView(saleAdvance.customer);
                    this.customerLabel = saleAdvance.customer.lastName + " " + saleAdvance.customer.firstName;
                } else {
                    this.isOccasionalCustomer = true;
                }

                this.dayId = saleAdvance.dayId;
                if (saleAdvance.day !== null) {
                    const dayIndex = DayData.getIndexOf(saleAdvance.day);
                    this.dayView = new DayView(dayIndex);
                }

                this.estimationNumber = saleAdvance.estimationNumber;
                this.advanceNumber = saleAdvance.advanceNumber;
                this.hrSellerId = saleAdvance.hrSellerId;
                if (saleAdvance.hrSeller !== null) {
                    this.hrSellerView = new HumanResourceView(saleAdvance.hrSeller);
                }
                if (saleAdvance.hrOp !== null) {
                    this.hrOpView = new HumanResourceView(saleAdvance.hrOp);
                }
                if (saleAdvance.site) {
                    this.siteView = new SiteView(saleAdvance.site);
                }
                this.siteV = saleAdvance.siteV;
                this.softV = saleAdvance.softV;
                this.signature = saleAdvance.signature;
                this.pSignature = saleAdvance.pSignature;
                this.signatureCode = saleAdvance.signatureCode;
                this.dsignatureCode = saleAdvance.dsignatureCode;
                this.vat = saleAdvance.vat;
                this.vatCode = saleAdvance.vatCode;
                this.servicesPrice = saleAdvance.servicesPrice;
                this.productsPrice = saleAdvance.productsPrice;
                this.curesPrice = saleAdvance.curesPrice;
                this.giftItemsPrice = saleAdvance.giftItemsPrice;
                this.loyaltyCardsPrice = saleAdvance.loyaltyCardsPrice;
                this.productsPriceWithD = this.productsPrice - this.productsPrice * this.discountPercent / 100;
                this.servicesPriceWithD = this.servicesPrice - this.servicesPrice * this.discountPercent / 100;
                this.curesPriceWithD = this.curesPrice - this.curesPrice * this.discountPercent / 100;
                this.giftItemsPriceWithD = this.giftItemsPrice - this.giftItemsPrice * this.discountPercent / 100;
                this.loyaltyCardsPriceWithD = this.loyaltyCardsPrice - this.loyaltyCardsPrice * this.discountPercent / 100;
                this.price = saleAdvance.price;
                this.priceHT = saleAdvance.priceHT;
                this.priceTurnover = saleAdvance.priceTurnover;
                this.priceTurnoverHT = saleAdvance.priceTurnoverHT;
                this.vatPrice = saleAdvance.vatPrice;
                this.advancePrice = saleAdvance.advancePrice;
                this.oExt = saleAdvance.oExt;
                this.discountPercent = saleAdvance.discountPercent;
                this.isCreatedByCustomer = saleAdvance.isCreatedByCustomer;
                this.nbPrint = saleAdvance.nbPrint;
                this.loyaltyCardItemId = saleAdvance.loyaltyCardItemId;
                if (saleAdvance.loyaltyCardItem !== null) {
                    this.loyaltyCardItemView = new LoyaltyCardItemView(saleAdvance.loyaltyCardItem, null, 0, null, this.posView);
                    let allItemsPrice = saleAdvance.getAllItemsPrice();
                    this.calculateUsedLoyaltyPts(allItemsPrice);
                }
                this.loyaltyPts = saleAdvance.loyaltyPts;
                this.totalLoyaltyPts = saleAdvance.totalLoyaltyPts;
                this.hasLoyaltyDiscount = saleAdvance.hasLoyaltyDiscount;
                this.loyaltyDate = saleAdvance.loyaltyDate;
                this.companyName = saleAdvance.companyName;
                this.paymentsView = [];
                if (saleAdvance.payments) {
                    for (let i = 0; i < saleAdvance.payments.length; i++) {
                        const payment = saleAdvance.payments[i];
                        this.paymentsView.push(new PaymentView(payment));
                        if (payment.type === "UNPAID") {
                            this.hasUnpaid = true;
                        }
                        if (this.paymentsView[i].type !== "UNPAID" && this.paymentsView[i].type !== "GIFT") {
                            this.realPaidPrice += this.paymentsView[i].price;
                        }
                    }
                }
                this.customerLastname = saleAdvance.customerLastname;
                this.customerFirstname = saleAdvance.customerFirstname;
                this.customerAddress = saleAdvance.customerAddress;
                this.customerZip = saleAdvance.customerZip;
                this.customerCity = saleAdvance.customerCity;
                this.shareCapital = saleAdvance.shareCapital;
                this.greffeCity = saleAdvance.greffeCity;
                this.juridicForm = saleAdvance.juridicForm;
            }
        };

        SaleAdvanceView.prototype.loadSaleServicesDataFrom = function (saleAdvance) {
            if (saleAdvance) {
                for (let i = 0; i < saleAdvance.saleServices.length; i++) {
                    const saleService = saleAdvance.saleServices[i];
                    const saleServiceView = new SaleServiceView(saleService, null, i + 1);
                    this.saleServicesView.push(saleServiceView);
                }
            }
        };

        SaleAdvanceView.prototype.loadSaleProductsDataFrom = function (saleAdvance) {
            if (saleAdvance) {
                for (let i = 0; i < saleAdvance.saleProducts.length; i++) {
                    const saleProduct = saleAdvance.saleProducts[i];
                    const saleProductView = new SaleProductView(saleProduct, null, i + 1);
                    this.saleProductsView.push(saleProductView);
                }
            }
        };

        SaleAdvanceView.prototype.loadSaleCuresDataFrom = function (saleAdvance) {
            if (saleAdvance) {
                for (let i = 0; i < saleAdvance.saleCures.length; i++) {
                    const saleCure = saleAdvance.saleCures[i];
                    const billPosition = this.saleProductsView.length + i + 1;
                    const saleCureView = new SaleCureView(saleCure, null, billPosition, this);
                    this.saleCuresView.push(saleCureView);
                }
            }
        };

        SaleAdvanceView.prototype.loadGiftItemsDataFrom = function (saleAdvance) {
            if (saleAdvance) {
                for (let i = 0; i < saleAdvance.giftItems.length; i++) {
                    const giftItem = saleAdvance.giftItems[i];
                    const billPosition = this.saleProductsView.length + this.saleCuresView.length + i + 1;
                    const giftItemView = new GiftItemView(giftItem, null, billPosition, this);
                    this.giftItemsView.push(giftItemView);
                }
            }
        };

        SaleAdvanceView.prototype.loadLoyaltyCardItemsDataFrom = function (saleAdvance) {
            if (saleAdvance) {
                let oneLoyaltyCardItemView;
                for (let i = 0; i < saleAdvance.loyaltyCardItems.length; i++) {
                    const oneLoyaltyCardItem = saleAdvance.loyaltyCardItems[i];
                    const billPosition = this.saleProductsView.length + this.saleCuresView.length + this.giftItemsView.length + i + 1;
                    oneLoyaltyCardItemView = new LoyaltyCardItemView(oneLoyaltyCardItem, null, billPosition, this);
                    this.loyaltyCardItemsView.push(oneLoyaltyCardItemView);
                }
                if (this.status === SaleStatus.WAITING && !this.loyaltyDate && oneLoyaltyCardItemView) {
                    this.loyaltyDate = oneLoyaltyCardItemView.validityDate;
                }
            }
        };

        SaleAdvanceView.prototype.calculateSaleFields = function () {
            let discountValue = 0;

            let discountPercent = this.discountPercent;
            if (this.discountPercent && typeof this.discountPercent === 'string') {
                discountPercent = this.discountPercent.replace(",", ".").replace(" ", "");
                discountPercent = parseFloat(discountPercent);
            }

            let allItemsPrice = this.productsPrice + this.curesPrice + this.servicesPrice + this.giftItemsPrice + this.loyaltyCardsPrice;
            if (this.loyaltyCardItemView) {
                if (this.nbLoyaltyCardGoal > 0 && this.loyaltyCardItemView.goalType !== "special") {
                    discountPercent = 0;
                    discountValue = 0;
                }

                this.calculateUsedLoyaltyPts(allItemsPrice);
                this.hasLoyaltyDiscount = false;
                if (this.nbLoyaltyCardGoal > 0)//goal reached : apply discount
                {
                    this.loyaltyDiscount += this.loyaltyCardItemView.computeLoyaltyDiscount(this.loyaltyPts);
                    this.hasLoyaltyDiscount = (this.loyaltyDiscount > 0);
                    if (this.loyaltyCardItemView.goalType === "discountValue") {
                        discountValue += this.loyaltyDiscount;
                    }
                    if (this.loyaltyCardItemView.goalType === "discountPercent" && this.loyaltyCardsPrice === 0) {//Can apply if discount is loyaltyCardsPrice has price
                        discountPercent += this.loyaltyDiscount;
                    }
                }
            }

            if (discountPercent && discountPercent !== 0) {
                discountValue += (discountPercent * allItemsPrice / 100);
            }
            this.price = Math.round(((allItemsPrice) - discountValue) * 100) / 100;
            this.priceInput = $filter('currencyFormatFilter')(this.price);
            if (this.loyaltyCardItemView) {
                this.updatePercent();
            }
            this.productsPriceWithD = Math.round((this.productsPrice - this.productsPrice * this.discountPercent / 100) * 100) / 100;
            this.curesPriceWithD = Math.round((this.curesPrice - this.curesPrice * this.discountPercent / 100) * 100) / 100;
            this.servicesPriceWithD = Math.round((this.servicesPrice - this.servicesPrice * this.discountPercent / 100) * 100) / 100;
            this.giftItemsPriceWithD = Math.round((this.giftItemsPrice - this.giftItemsPrice * this.discountPercent / 100) * 100) / 100;
            this.loyaltyCardsPriceWithD = Math.round((this.loyaltyCardsPrice - this.loyaltyCardsPrice * this.discountPercent / 100) * 100) / 100;

            this.payedPrice = 0;
            for (let i = 0; i < this.paymentsView.length; i++) {
                this.payedPrice += this.paymentsView[i].price;
            }
            this.currentPayment = this.price - this.payedPrice;

            this.calculateVatLines();
            this.calculateEarnedLoyaltyPts();
        };

        SaleAdvanceView.prototype.updatePercent = function() {
            const originalPrice =  this.productsPrice + this.curesPrice + this.servicesPrice + this.giftItemsPrice + this.loyaltyCardsPrice;
            if (originalPrice !== 0){
                this.discountPercent = Math.round(10000000*(100- 100* this.price/originalPrice))/10000000;
            }
            else{
                this.discountPercent = 0;
            }
        };

        SaleAdvanceView.prototype.calculateEarnedLoyaltyPts = function () {
            this.loyaltyPts = 0;
            if (this.loyaltyCardItemView) {
                let loyaltyBasedPrice = this.price - this.loyaltyCardsPriceWithD;
                if (this.paymentsView.length !== 0) {
                    let giftPrice = 0;
                    for (let i = 0; i < this.paymentsView.length; i++) {
                        if (this.paymentsView[i].type === "GIFT") {
                            giftPrice += this.paymentsView[i].price;
                        }
                    }
                    loyaltyBasedPrice -= giftPrice;
                }
                this.loyaltyPts = Math.round((this.loyaltyCardItemView.ptsByCa * loyaltyBasedPrice + this.loyaltyCardItemView.ptsBySale));
            }
        };

        SaleAdvanceView.prototype.calculateUsedLoyaltyPts = function (allItemsPrice) {
            this.loyaltyPts = 0;
            this.loyaltyUsedPts = 0;
            if (this.loyaltyCardItemView && this.nbLoyaltyCardGoal !== -1) {
                let hasLoyaltyCardInShoppingCart = this.loyaltyCardItemsView.length > 0;
                this.nbLoyaltyCardGoal = this.loyaltyCardItemView.nbLoyaltyCardGoal(allItemsPrice, null, hasLoyaltyCardInShoppingCart);
            }
            if (this.loyaltyCardItemView && this.nbLoyaltyCardGoal === 1) {//-> Not goal reached : generate points
                this.loyaltyPts = -this.loyaltyCardItemView.getGoalPoints(allItemsPrice);//goal reached -> generate negative points
                this.loyaltyUsedPts = this.loyaltyPts;
            }
        }

        SaleAdvanceView.prototype.calculateVatLines = function () {
            this.vatLines = this.initVatLines();
            let defaultVat = null;

            if (this.posView && this.posView.domainView) {
                defaultVat = this.posView.domainView.getDefaultVatTax();
            }

            if (defaultVat != null) {
                let priceWithD;
                if (this.bookingView) {
                    for (let i = 0; i < this.bookingView.bookingServicesView.length; i++) {
                        priceWithD = this.bookingView.bookingServicesView[i].price - this.bookingView.bookingServicesView[i].price * this.discountPercent / 100;
                        this.addVatAmount(defaultVat, priceWithD - priceWithD * 100 / (100 + defaultVat), priceWithD * 100 / (100 + defaultVat));
                    }
                } else {
                    for (let i = 0; i < this.saleServicesView.length; i++) {
                        priceWithD = this.saleServicesView[i].price - this.saleServicesView[i].price * this.discountPercent / 100;
                        this.addVatAmount(defaultVat, priceWithD - priceWithD * 100 / (100 + defaultVat), priceWithD * 100 / (100 + defaultVat));
                    }
                }
                for (let i = 0; i < this.saleCuresView.length; i++) {
                    priceWithD = this.saleCuresView[i].price - this.saleCuresView[i].price * this.discountPercent / 100;
                    this.addVatAmount(defaultVat, priceWithD - priceWithD * 100 / (100 + defaultVat), priceWithD * 100 / (100 + defaultVat));
                }
                for (let i = 0; i < this.loyaltyCardItemsView.length; i++) {
                    priceWithD = this.loyaltyCardItemsView[i].price - this.loyaltyCardItemsView[i].price * this.discountPercent / 100;
                    this.addVatAmount(defaultVat, priceWithD - priceWithD * 100 / (100 + defaultVat), priceWithD * 100 / (100 + defaultVat));
                }

                for (let i = 0; i < this.saleProductsView.length; i++) {
                    priceWithD = this.saleProductsView[i].price - this.saleProductsView[i].price * this.discountPercent / 100;
                    if (this.saleProductsView[i].vat == null) {
                        this.addVatAmount(defaultVat, priceWithD - priceWithD * 100 / (100 + defaultVat), priceWithD * 100 / (100 + defaultVat));
                    } else {
                        this.addVatAmount(this.saleProductsView[i].vat, priceWithD - priceWithD * 100 / (100 + this.saleProductsView[i].vat), priceWithD * 100 / (100 + this.saleProductsView[i].vat));
                    }
                }
            }

            let totalVat = 0;
            let maxAmount = 0;
            for (let i = 0; i < this.vatLines.length; i++) {
                this.vatLines[i].amount = Math.round(this.vatLines[i].amount * 100) / 100;
                totalVat += this.vatLines[i].amount;
                if (this.vatLines[i].amount >= maxAmount) {
                    maxAmount = this.vatLines[i].amount;
                    this.vat = this.vatLines[i].tax;
                    this.vatCode = this.vatLines[i].code;
                }
            }

            if (totalVat === 0) {
                let maxHt = 0;
                for (let i = 0; i < this.vatLines.length; i++) {
                    this.vatLines[i].amount = Math.round(this.vatLines[i].amount * 100) / 100;
                    if (this.vatLines[i].ht >= maxHt) {
                        maxHt = this.vatLines[i].ht;
                        this.vat = this.vatLines[i].tax;
                        this.vatCode = this.vatLines[i].code;
                    }
                }
            }
            this.priceHT = this.price - totalVat;
        };

        SaleAdvanceView.prototype.initVatLines = function () {
            let vatTaxes = [];

            if (this.posView && this.posView.domainView) {
                let vatsView = this.posView.domainView.getVatsView();
                if (vatsView) {
                    for (let i = 0; i < vatsView.length; i++) {
                        if (vatsView[i].isUsable) {
                            vatTaxes.push({tax: vatsView[i].tax, code: vatsView[i].code, amount: 0, ht: 0});
                        }
                    }
                }
            }
            return vatTaxes;
        };

        SaleAdvanceView.prototype.addVatAmount = function (tax, amount, ht) {
            let vatLine = null;
            for (let i = 0; i < this.vatLines.length; i++) {
                if (this.vatLines[i].tax === tax) {
                    vatLine = this.vatLines[i];
                }
            }
            if (!vatLine) {
                this.vatLines.push({tax: tax, amount: amount, ht: ht});
            } else {
                vatLine.amount += amount;
                vatLine.ht += ht;
            }
        };

        SaleAdvanceView.prototype.hasCustomerWithEmail = function () {
            return this.customerView && this.customerView.email;
        };

        SaleAdvanceView.prototype.openPrintWindow = function () {
            let left = (screen.width / 2) - (800 / 2);
            let top = (screen.height / 2) - (500 / 2);
            this.printWindow = window.open('', '_blank', 'width=800,height=500,left=' + left + ',top=' + top + ',scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no')
            if (this.printWindow) {
                this.printWindow.window.focus();
            }
        };

        SaleAdvanceView.prototype.getDiscount = function (saleAdvanceItem, quantity) {
            let discountTTC = 0;
            if (saleAdvanceItem.discountPercent > 0) {
                if (saleAdvanceItem.discountPercent === 100) {
                    discountTTC = saleAdvanceItem.originalPrice * quantity;
                } else {
                    discountTTC = saleAdvanceItem.price / (1 - saleAdvanceItem.discountPercent / 100) - saleAdvanceItem.price;
                }
            }
            return discountTTC;
        };

        SaleAdvanceView.prototype.getDiscountGlobalTTC = function (saleItem, discountTTC) {
            let discountRemise = 0;
            if (this.discountPercent > 0 && discountTTC !== saleItem.originalPrice) {
                discountRemise += saleItem.price * this.discountPercent / 100;
            }
            return discountRemise;
        };

        SaleAdvanceView.prototype.addLineOnPrint = function (saleItem, quantity, discountTTC, label) {
            let vat = (saleItem.vat || saleItem.vat === 0) ? saleItem.vat : "20";
            let price = saleItem.originalPrice;
            let priceHT = saleItem.originalPrice / ((vat / 100) + 1);
            let finalLabel = priceHT === 0 ? label + "</br>" + gettextCatalog.getString("Code 328 gratuité totale") : label;
            let lineContent = '' +
                '<tr>' +
                '<td style="width:13px">' + quantity + '</td>' +
                '<td>' + finalLabel + '</td>' +
                '<td>' + gettextCatalog.getString("Code TVA") + " : " + saleItem.vatCode + '</td>' +
                '<td>' + gettextCatalog.getString("TVA") + ' = ' + vat + '%</td>' +
                '<td>' + gettextCatalog.getString("Prix Unitaire HT") + ' = ' + $filter('currencyFormatFilter')(priceHT) + '</td>' +
                '<td>' + gettextCatalog.getString("Prix Unitaire TTC") + ' = ' + $filter('currencyFormatFilter')(price) + '</td>' +
                '<td>' + gettextCatalog.getString("Prix Total HT") + ' = ' + $filter('currencyFormatFilter')(priceHT * quantity) + '</td>' +
                '<td>' + gettextCatalog.getString("Prix Total TTC") + ' = ' + $filter('currencyFormatFilter')(price * quantity) + '</td>' +
                '</tr>';
            let discountP = discountTTC * 100 / (saleItem.originalPrice * quantity);
            if (discountP > 0) {
                lineContent += '' +
                    '<tr>' +
                    '<td style="width:13px"></td>' +
                    '<td style="font-style: italic"><span>' + gettextCatalog.getString("Remise de") + '</span> ' + $filter('number')(discountP, 2) + '%</td>' +
                    '<td></td>' +
                    '<td class="price">-' + $filter('currencyFormatFilter')(discountTTC) + '</td>' +
                    '</tr>';
            }
            return lineContent;
        };

        SaleAdvanceView.prototype.printSell = function () {
            if (this.printWindow) {
                let site = this.siteView ? this.siteView : SiteData.defaultSite;

                let onLoadContent = "window.print();setTimeout(function(){window.close();}, 1);";
                if (IOSDevice.isIOSDevice()) {
                    onLoadContent = "window.print();";
                }

                let documentContent = '<!DOCTYPE html><html><head>' +
                    '<link rel="stylesheet" type="text/css" href="/css/print.css" />' +
                    '<script src="//ajax.googleapis.com/ajax/libs/jquery/1.11.1/jquery.min.js"></script>' +
                    '<script src="/lib/barcode/JsBarcode.js"></script>' +
                    '<script src="/lib/barcode/EAN_UPC.js"></script>' +
                    '</head><body onload="' + onLoadContent + '"><div class="reward-body">' +
                    '<div class="company">' +
                    '<div class="name">' + site.name + '</div>';

                if (site.siret && site.siret !== "" && site.country === Countries.FRANCE.countryCode) {
                    documentContent += '<div class="address">' + gettextCatalog.getString("N° siret") + " : " + site.siret + '</div>';
                }
                if (site.vatNumber && site.vatNumber !== "") {
                    documentContent += '<div class="address">' + gettextCatalog.getString("N° TVA") + " : " + site.vatNumber + '</div>';
                }
                if (site.rcs && site.rcs !== "") {
                    documentContent += '<div class="address">' + gettextCatalog.getString("N°RCS") + " : " + site.rcs + '</div>';
                }
                if (site.nafCode && site.nafCode !== "") {
                    documentContent += '<div class="address">' + gettextCatalog.getString("Code NAF") + " : " + site.nafCode + '</div>';
                }

                const juridicForm = this.juridicForm ? this.juridicForm : '';
                const greffeCity = this.greffeCity ? ' Immatriculé au Greffe de : ' + this.greffeCity : '';
                const shareCapital = this.shareCapital ? 'Société au capital de : ' + this.shareCapital : '';
                documentContent += '<div class="address"> ' + juridicForm + greffeCity + '</div>';
                documentContent += '<div class="address">' + shareCapital + '</div>';

                if (site.address && site.address !== "") {
                    documentContent += '<div class="address">' + site.address + '</div>';
                    documentContent += '<div class="address">' + site.postalCode + ' ' + site.city;

                    if (Countries.map[site.country]) {
                        documentContent += ' ' + Countries.map[site.country].countryName;
                    }
                    documentContent += '</div>';
                }

                if (site.phone && site.phone !== "") {
                    documentContent += '<div class="phone">' + site.phone + '</div>';
                }
                if (this.dayView) {
                    let currentDateTime = new Date();
                    let labelDate = $filter('date')(currentDateTime, 'EEEE d MMMM yyyy');
                    let labelTime = gettextCatalog.getString("A_TIME") + ' ' + $filter('date')(currentDateTime, "H':'mm':'ss.sss");
                    let labelDateTimeCapitalized = labelDate.charAt(0).toUpperCase() + labelDate.substring(1) + ' ' + labelTime;
                    documentContent += '</div>' +
                        '<div class="global-info">' +
                        '<div class="date">' + gettextCatalog.getString("Date") + " : " + labelDateTimeCapitalized + '</div>';
                }
                if (this.hrSellerView) {
                    documentContent += '<div class="hr">' + gettextCatalog.getString("Encaissé par") + " : " + this.hrSellerView.label + '</div>';
                }

                if (this.customerView && this.customerLastname && this.customerFirstname) {
                    documentContent += '<div class="customer">' + gettextCatalog.getString("Client") + " : " + this.customerFirstname + ' ' + this.customerLastname + '</div>';
                    if (this.customerAddress && this.customerZip && this.customerCity) {
                        documentContent += '<div class="customer">' + this.customerAddress + ' ' + this.customerCity + ' ' + this.customerZip + '</div>';
                    }
                } else {
                     documentContent += '<div class="customer">' + gettextCatalog.getString("Client") + " : " + gettextCatalog.getString("De passage") + '</div>';
                }

                let nbItems = this.saleServicesView.length + this.saleProductsView.length + this.saleCuresView.length + this.giftItemsView.length + this.loyaltyCardItemsView.length;
                documentContent += '<div class="customer">' + gettextCatalog.getString("Facture d'acompte n°") + " : " + this.advanceNumber + ' (' + nbItems + ' lig.)</div>';

                if (this.signatureCode) {
                    documentContent += '<div class="customer">' + gettextCatalog.getString("Signature ticket") + " : " + this.signatureCode + '</div>';
                }
                if (this.posView && this.posView.domainView.scope.ad.loggedUser.serverIdentification.version) {
                    documentContent += '<div class="customer">' + gettextCatalog.getString("Logiciel") + " : " + Brand.label + ' V' + this.computeSoftV() + '(NF525)</div>';
                }
                documentContent += '</div><table class="bill">';

                let saleDiscountTTC = 0;
                let saleItemDiscountTTC = 0;
                let totalTTC = 0;

                for (let i = 0; i < this.saleServicesView.length; i++) {
                    let discountTTC = this.getDiscount(this.saleServicesView[i], 1);
                    totalTTC += this.saleServicesView[i].originalPrice;
                    saleDiscountTTC += discountTTC;
                    saleItemDiscountTTC = this.getDiscountGlobalTTC(this.saleServicesView[i], discountTTC) + saleItemDiscountTTC;
                    documentContent += this.addLineOnPrint(this.saleServicesView[i], 1, discountTTC, this.saleServicesView[i].label);
                }

                for (let i = 0; i < this.saleProductsView.length; i++) {
                    let discountTTC = this.getDiscount(this.saleProductsView[i], this.saleProductsView[i].quantity);
                    totalTTC += this.saleProductsView[i].originalPrice * this.saleProductsView[i].quantity;
                    saleDiscountTTC += discountTTC;
                    saleItemDiscountTTC = this.getDiscountGlobalTTC(this.saleProductsView[i], discountTTC) + saleItemDiscountTTC;
                    documentContent += this.addLineOnPrint(this.saleProductsView[i], this.saleProductsView[i].quantity, discountTTC, this.saleProductsView[i].label);
                }

                for (let i = 0; i < this.saleCuresView.length; i++) {
                    let discountTTC = this.getDiscount(this.saleCuresView[i], this.saleCuresView[i].quantity);
                    totalTTC += this.saleCuresView[i].originalPrice * this.saleCuresView[i].quantity;
                    saleDiscountTTC += discountTTC;
                    saleItemDiscountTTC = this.getDiscountGlobalTTC(this.saleCuresView[i], discountTTC) + saleItemDiscountTTC;
                    documentContent += this.addLineOnPrint(this.saleCuresView[i], this.saleCuresView[i].quantity, discountTTC, this.saleCuresView[i].label);
                }

                for (let i = 0; i < this.loyaltyCardItemsView.length; i++) {
                    let discountTTC = this.getDiscount(this.loyaltyCardItemsView[i], 1);
                    totalTTC += this.loyaltyCardItemsView[i].originalPrice;
                    saleDiscountTTC += discountTTC;
                    saleItemDiscountTTC = this.getDiscountGlobalTTC(this.loyaltyCardItemsView[i], discountTTC) + saleItemDiscountTTC;
                    documentContent += this.addLineOnPrint(this.loyaltyCardItemsView[i], 1, discountTTC, this.loyaltyCardItemsView[i].label);
                }

                let totalDiscountTTC = saleItemDiscountTTC + saleDiscountTTC;
                if (this.discountPercent !== 0 && saleItemDiscountTTC) {
                    let gratuityLabel = this.discountPercent >= 100 ? gettextCatalog.getString("</br>Code 328 gratuité totale") : "";
                    documentContent += '' +
                        '<tr>' +
                        '<td colspan="3" style="width:30px">' + gettextCatalog.getString("Remise globale") + ' ' + $filter('number')(this.discountPercent, 2) + '%' + gratuityLabel + '</td>' +
                        '<td class="price">-' + $filter('currencyFormatFilter')(saleItemDiscountTTC) + '</td>' +
                        '</tr>';
                }

                if (this.saleServicesView.length || this.saleProductsView.length || this.saleCuresView.length) {
                    documentContent += '' +
                        '<tr>' +
                        '<td colspan="3" style="font-weight: bold">' + gettextCatalog.getString("Total TTC") + '</td>' +
                        '<td class="price" style="font-weight: bold">' + $filter('currencyFormatFilter')(totalTTC - totalDiscountTTC) + '</td>' +
                        '</tr>';
                }

                if (totalDiscountTTC) {
                    documentContent += '' +
                        '<tr>' +
                        '<td colspan="3">' + gettextCatalog.getString("Total remises TTC") + '</td>' +
                        '<td class="price">' + $filter('currencyFormatFilter')(totalDiscountTTC) + '</td>' +
                        '</tr>';
                }

                documentContent += '</table>';

                documentContent += '<table class="bill">';

                let giftGlobalDiscountTTC = 0;
                let documentContentGift = '';
                for (let i = 0; i < this.giftItemsView.length; i++) {
                    let giftItemView = this.giftItemsView[i];
                    let giftDiscountTTC = this.getDiscount(giftItemView, 1);
                    giftGlobalDiscountTTC += this.getDiscountGlobalTTC(giftItemView, giftDiscountTTC);
                    documentContentGift += '' +
                        '<tr>' +
                        '<td colspan="4">' + gettextCatalog.getString("1 Chèque cadeau") + '</td>' +
                        '<td class="price">' + $filter('currencyFormatFilter')(giftItemView.originalPrice) + '</td>' +
                        '</tr>';
                    if (giftDiscountTTC) {
                        documentContentGift += '' +
                            '<td colspan="4" style="width:30px">' + gettextCatalog.getString("Remise de") + ' ' + $filter('number')(giftItemView.discountPercent, 2) + '%</td>' +
                            '<td class="price">-' + $filter('currencyFormatFilter')(giftDiscountTTC) + '</td>' +
                            '</tr>';
                    }
                }

                if (giftGlobalDiscountTTC) {
                    documentContentGift += '' +
                        '<tr>' +
                        '<td colspan="4">' + gettextCatalog.getString("Remise globale") + ' ' + $filter('number')(this.discountPercent, 2) + '%</td>' +
                        '<td class="price">-' + $filter('currencyFormatFilter')(giftGlobalDiscountTTC) + '</td>' +
                        '</tr>';
                }

                if (documentContentGift !== '') {
                    documentContent += documentContentGift;
                }

                if (this.saleServicesView.length || this.saleProductsView.length || this.saleCuresView.length) {
                    documentContent += '' +
                        '<tr>' +
                        '<td class="price-tva" style="width:30px;text-align: left">' + gettextCatalog.getString("Code") + '</td>' +
                        '<td class="price-tva" style="width:30px"></td>' +
                        '<td class="price-tva">' + gettextCatalog.getString("TOTAL TVA") + '</td>' +
                        '<td class="price-tva">' + gettextCatalog.getString("TOTAL HT") + '</td>' +
                        '<td class="price-tva">' + gettextCatalog.getString("TOTAL TTC") + '</td>' +
                        '</tr>';

                    let totalVat = 0,
                        totalHT = 0,
                        totalTTC = 0;

                    for (let i = 0; i < this.vatLines.length; i++) {
                        if ((this.posView && this.posView.domainView && this.posView.domainView.getDefaultVatTax() === this.vatLines[i].tax)
                            || (this.vatLines[i].amount !== 0 || this.vatLines[i].ht !== 0)) {

                            //var ht = this.vatLines[i].amount / (this.vatLines[i].tax) * 100;
                            let ht = this.vatLines[i].ht;

                            totalVat += (this.vatLines[i].amount ? this.vatLines[i].amount : 0);
                            totalHT += (ht ? ht : 0);
                            totalTTC += (this.vatLines[i].amount ? this.vatLines[i].amount : 0) + (ht ? ht : 0);

                            documentContent += '' +
                                '<tr>' +
                                '<td class="price-tva" style="text-align:left">' + this.vatLines[i].code + '</td>' +
                                '<td class="price-tva">' + $filter('number')(this.vatLines[i].tax, 2) + '%' + '</td>' +
                                '<td class="price-tva">' + $filter('currencyFormatFilter')(this.vatLines[i].amount) + '</td>' +
                                '<td class="price-tva">' + $filter('currencyFormatFilter')(ht) + '</td>' +
                                '<td class="price-tva">' + $filter('currencyFormatFilter')(this.vatLines[i].amount + ht) + '</td>' +
                                '</tr>';
                        }
                    }
                    documentContent += '' +
                        '<tr>' +
                        '<td class="price-tva" style="width:30px;text-align: left">' + gettextCatalog.getString("Total") + '</td>' +
                        '<td class="price-tva" style="width:30px"></td>' +
                        '<td class="price-tva">' + $filter('currencyFormatFilter')(totalVat) + '</td>' +
                        '<td class="price-tva">' + $filter('currencyFormatFilter')(totalHT) + '</td>' +
                        '<td class="price-tva">' + $filter('currencyFormatFilter')(totalTTC) + '</td>' +
                        '</tr>';
                }

                documentContent += '' +
                    '<tr>' +
                    '<td colspan="5" class="separator"></td>' +
                    '</tr>' +
                    '<tr>' +
                    '<td colspan="4">' + gettextCatalog.getString("Règlement(s)") + '</td>' +
                    '<td></td>' +
                    '</tr>';

                if (this.advancePrice !== 0) {
                    documentContent += '' +
                        '<tr>' +
                        '<td colspan="5" class="separator"></td>' +
                        '</tr>' +
                        '<tr>' +
                        '<td colspan="4">' + gettextCatalog.getString("Montant de l\'acompte : ") + '</td>' +
                        '<td>' + $filter('currencyFormatFilter')(this.advancePrice) + '</td>' +
                        '</tr>';

                    documentContent += '' +
                        '<tr>' +
                        '<td colspan="4">' + gettextCatalog.getString("Taux : ") + '</td>' +
                        '<td>' + $filter('number')(Math.abs((this.advancePrice / this.price) * 100), 2) + '%</td>' +
                        '</tr>' +
                        '<tr>' +
                        '<td colspan="5" class="separator"></td>' +
                        '</tr>';
                }

                let payed = 0;
                let advanceNumberAdded = false;
                for (let i = 0; i < this.paymentsView.length; i++) {
                    documentContent += '' +
                        '<tr>' +
                        '<td>';

                    if (this.paymentsView[i].type !== 'UNPAID') {
                        documentContent += $filter('date')(this.paymentsView[i].date, 'shortDate');
                    }
                    documentContent += '</td><td colspan="3">';

                    let salePaymentType = SalePaymentTypeFactory.from(this.paymentsView[i].type);
                    if (salePaymentType) {
                        documentContent += salePaymentType.label;
                    } else if (this.paymentsView[i].otherPaymentTypeView) {
                        documentContent += this.paymentsView[i].otherPaymentTypeView.label;
                    }

                    if (!advanceNumberAdded && this.advanceNumber) {
                        documentContent += " " + gettextCatalog.getString("Acompte n°") + this.advanceNumber;
                        advanceNumberAdded = true;
                    }

                    documentContent += '' +
                        '</td>' +
                        '<td class="price">' + $filter('currencyFormatFilter')(this.paymentsView[i].price) + '</td>' +
                        '</tr>';
                    payed += this.paymentsView[i].price;
                }
                if ((this.price - payed > 0)) {
                    documentContent += '' +
                        '<tr>' +
                        '<td></td>' +
                        '<td colspan="3">' + gettextCatalog.getString("Reste à payer") + '</td>' +
                        '<td class="price">' + $filter('currencyFormatFilter')(this.price - payed) + '</td>' +
                        '</tr>';
                }

                documentContent += '' +
                    '<tr>' +
                    '<td colspan="5" class="separator"></td>' +
                    '</tr>' +
                    '<tr>' +
                    '<td colspan="5" class="separator"></td>' +
                    '</tr>' +
                    '</table>';

                if (this.loyaltyCardItemView) {
                    documentContent += "<table class=\"loyalty\">";
                    documentContent += '<tr><td>' + gettextCatalog.getString("Fidélité") + '</td><td>' + this.loyaltyCardItemView.label + "</td></tr>";
                    if (this.loyaltyCardItemView.type !== "subs") {
                        documentContent += '<tr><td>' + gettextCatalog.getString("Nouveau solde") + '</td><td>' + this.totalLoyaltyPts + " pts</td></tr>";
                        documentContent += '<tr><td>' + gettextCatalog.getString("Ancien solde") + '</td><td>' + (this.totalLoyaltyPts - this.loyaltyPts) + " pts</td></tr>";
                        documentContent += '<tr><td>' + gettextCatalog.getString("Point cumulé") + '</td><td>' + (this.hasLoyaltyDiscount ? this.loyaltyPts + this.loyaltyCardItemView.goalPts : this.loyaltyPts) + " pts</td></tr>";
                        if (this.nbLoyaltyCardGoal <= 0) {
                            documentContent += "<tr><td>";

                            if ((this.loyaltyCardItemView.pts) < this.loyaltyCardItemView.goalPts) {
                                documentContent += gettextCatalog.getString("Prochaine récompense") + ' </td><td>' + this.loyaltyCardItemView.goalPts + " pts";
                            } else {
                                documentContent += gettextCatalog.getString("Au prochain achat") + '</td><td>';
                                if (this.loyaltyCardItemView.goalType === "special") {
                                    documentContent += this.loyaltyCardItemView.goalText;
                                } else {
                                    documentContent += "Remise de " + this.loyaltyCardItemView.computeGoalAmountNextSale();
                                    if (this.loyaltyCardItemView.goalType === "discountValue") {
                                        documentContent += " " + CurrencyManager.getCurrencySymbol();
                                    } else {
                                        documentContent += " %";
                                    }
                                }
                                documentContent += "</td></tr>";
                            }
                        }
                    }

                    if (this.loyaltyCardItemView.validityDate) {
                        documentContent += '<tr><td>' + gettextCatalog.getString("Validité") + '</td><td>' + $filter('date')(this.loyaltyCardItemView.validityDate, 'shortDate') + "</td></tr></table>";
                    }
                }

                if (this.posView && this.posView.domainView.ticketEndText && this.posView.domainView.ticketEndText !== '') {
                    documentContent += '<div>' + this.posView.domainView.ticketEndText + '</div>';
                }

                for (let i = 0; i < this.giftItemsView.length; i++) {
                    if (this.giftItemsView[i].editionType !== "manual") {
                        documentContent += '<div style="border: 1px dotted black;margin: 5px;padding: 5px;text-align: center"><div style="font-size: 16px;padding-bottom: 3px">' + gettextCatalog.getString("Chèque cadeau de") + " " + $filter('currencyFormatFilter')(this.giftItemsView[i].originalPrice) + '</div><div><img id="barcode' + i + '"/></div><div>';
                        documentContent += this.giftItemsView[i].code;
                        documentContent += '</div><div>' + gettextCatalog.getString("Valable jusqu'au") + " " + $filter('date')(this.giftItemsView[i].validityDate, 'shortDate') + '</div></div><script>$(document).ready(function() {$("#barcode' + i + '").JsBarcode("';
                        documentContent += this.giftItemsView[i].code.replace(/-/g, "");
                        documentContent += '",{format:"EAN",displayValue:false,fontSize:16,height: 50});});</script>';
                    }
                }

                if (this.posView && this.posView.domainView.ticketEndDisplayBooking) {
                    let now = new Date();

                    if (this.customerView && this.customerView.globalHistoryView) {
                        let nextBooking = '<table class="bill" style="border: 1px dotted black;padding: 5px;text-align: center"><tr><th colspan="2" style="text-align:left">' + gettextCatalog.getString("Prochains rendez-vous") + '</th></tr>',
                            clonedHistory = this.customerView.globalHistoryView.copyWithin(0, 0),
                            hasNextBooking = false;

                        clonedHistory.sort(function (a, b) {
                            if (a.date < b.date) {
                                return -1;
                            }
                            if (a.date > b.date) {
                                return 1;
                            }
                            return 0;
                        });

                        for (let i = 0; i < clonedHistory.length; i++) {
                            let bookingTime = null;
                            if (clonedHistory[i].bookingPeriod && clonedHistory[i].bookingPeriod.start) {
                                bookingTime = clonedHistory[i].date.getTime() + clonedHistory[i].bookingPeriod.start.getTimeInMilli();
                            }

                            let filterdHistory = $filter('filter')(clonedHistory[i].items, {type: "service"});

                            if ((bookingTime && bookingTime > now.getTime()) && filterdHistory && filterdHistory.length !== 0) {
                                hasNextBooking = true;
                                nextBooking += '<tr>' +
                                    '<td style="width:120px;vertical-align:top;text-align:left;">' + $filter('date')(clonedHistory[i].date, 'shortDate') + " " + gettextCatalog.getString("à") + " " + clonedHistory[i].bookingTime + '</td>' +
                                    '<td style="vertical-align:top;text-align:left;padding-left:5px">' +
                                    '<span>' + filterdHistory[0].label + '</span>';

                                for (let j = 1; j < filterdHistory.length; j++) {
                                    nextBooking += '<span>, ' + filterdHistory[j].label + '</span>';
                                }
                                nextBooking += '</td></tr>';
                            }
                        }
                        nextBooking += '</table>';
                        if (hasNextBooking) {
                            documentContent += nextBooking;
                        }
                    }
                }

                documentContent += '</div></body></html>';
                this.printWindow.document.write(documentContent);
                this.printWindow.document.title = gettextCatalog.getString("Imprimer");
                this.printWindow.document.close();
            }
        };

        SaleAdvanceView.prototype.computeSoftV = function () {
            let softV;
            if (this.softV) {
                softV = this.softV.includes("backend") ? this.softV.substr(8) : this.softV;
                softV = softV.includes(".") ? softV.substr(0, softV.indexOf(".")) : softV;
            } else {
                softV = this.posView.domainView.scope.ad.loggedUser.serverIdentification.version;
            }
            return softV;
        };

        return SaleAdvanceView;
    }]);



// WEBPACK FOOTER //
// ./js/services/views/SaleAdvanceView.js